import { Config } from 'config';
import { OwnedObject, invalidateOwner } from 'gear';

import { Xml } from '../../util';


export const Font = OwnedObject.extend({ typeName: 'Font',

  Properties : {

    id            : { type: 'string', def: null, dropDef: true, tag: 'Guid', onChange: invalidateOwner },

    name          : { type: 'string', def: null, dropDef: true, onChange: invalidateOwner },

    familyName    : { type: 'string', def: null, dropDef: true, onChange: invalidateOwner },
    fullName      : { type: 'string', def: null, dropDef: true, onChange: invalidateOwner },
    postscriptName: { type: 'string', def: null, dropDef: true, onChange: invalidateOwner },

    weight        : { type: 'string' , def: null , dropDef: true, onChange: invalidateOwner },

    isBold        : { type: 'boolean', def: null, dropDef: true, onChange: invalidateOwner },
    isItalic      : { type: 'boolean', def: null, dropDef: true, onChange: invalidateOwner },
    isStrikeout   : { type: 'boolean', def: null, dropDef: true, onChange: invalidateOwner },
    isUnderline   : { type: 'boolean', def: null, dropDef: true, onChange: invalidateOwner }
  },

  uiName() {
    return this._fullName || this._familyName || this._postscriptName || this._name || this._id ;
  },

  textualize() {
    return this.toXmlString();
  },

  cache$() {
    const manager = Config.GlobalResourceManager;
    return manager.loadFontData$(this,'','M');
  },

  thumbnailUrl( config ) {
    return Config.GlobalResourceManager.fontThumbnailUrl( this, config );
  }

});

Font.parseXml = function ( node ) {
  const p = Xml.parseProperties(node,Font);
  if( !p.id && !p.fullName && !p.postscriptName && !p.familyName && !p.name ) {
    p.familyName = 'Arial';
  }
  return new Font(p);
};

Xml.addFromBuild(Font,'Font');
Xml.addToXml(Font);


Font.fromXmlString = function(xmlString) {
  const domFigure = Xml.fromString(xmlString);
  return Font.fromXml(domFigure.documentElement);
};

Font.defaultFont = function() {
  return new Font({ familyName: 'Stahls varsity' });
};



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/text/font.js
 **/